module.exports = __webpack_public_path__ + "img/[发怒].bc24f01e.svg";